import { useState } from "react";
import { Link } from "react-router-dom";
import SectionTitle from "@/components/base/SectionTitle";
import { faqs } from "@/mocks/faqs";

export default function FaqPreview() {
  const [open, setOpen] = useState<number | null>(0);
  const preview = faqs.slice(0, 4);

  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-4xl px-4 md:px-8">
        <SectionTitle
          eyebrow="用户常见问题"
          title="第一次来，先看这几条"
          align="center"
          description="关于板块划分、更新频率和内容反馈的常见疑问，这里先回答最常被问到的几个。"
        />

        <div className="mt-8 flex flex-col gap-3">
          {preview.map((item, index) => {
            const isOpen = open === index;
            return (
              <div key={item.q} className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : index)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  aria-expanded={isOpen}
                >
                  <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">{item.q}</span>
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-lg transition-colors ${
                      isOpen ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-700"
                    }`}
                  >
                    <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} />
                  </span>
                </button>
                {isOpen && (
                  <p className="border-t border-background-200 px-5 py-4 text-sm leading-relaxed text-foreground-600">
                    {item.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>

        <div className="mt-8 text-center">
          <Link
            to="/faq"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            查看全部常见问题
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}